const Detail = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) => {
  return (
    <div data-testid={`detail-${label}`}>
      <label className="text-[#A0A0A0]">{label}</label>
      <p>{value}</p>
    </div>
  );
};

export default Detail;
